module.exports = __webpack_public_path__ + "static/media/home.b5af630b.svg";